<template>
    <divided-section id="sek-blog">
        <template v-slot:left-section>
            <container-title
                title-color="#141517"
                :title="'Quem somos?'"
                sub-title="" />
            <h2 
                style="margin-bottom: 60px;"
                class="sek-blog-description white--text">
                "Somos uma Assessoria especializada no suporte técnico e comercial para 
                corretores de seguros e benefícios. Buscamos oferecer a cada assessorado, 
                um tratamento personalizado, aonde são analisadas todas as necessidades 
                encontradas na comercialização dos produtos existentes em nosso portfólio, 
                para adequá-las a soluções práticas que atendam o cliente final"

                <h5 class="white--text">Leonardo Araújo</h5>
            </h2>
            
            <div class="d-flex">
                <circular-button
                    outlined
                    class="sek-blog-section-left-btn white--text">
                    Saiba mais
                </circular-button>
                <v-spacer></v-spacer>
                <div class="btns d-flex">
                    <v-btn
                        color="black"
                        icon>
                        <v-icon
                            large 
                            color="white">
                            mdi-chevron-left
                        </v-icon>
                    </v-btn>
                    <v-btn
                        color="black"
                        class="ml-3"
                        icon>
                        <v-icon
                            large 
                            color="white">
                            mdi-chevron-right
                        </v-icon>
                    </v-btn>
                </div>
            </div>

        </template>

        <template 
            v-slot:right-section> 
            <img 
                :src="imgSrc">
        </template>
    </divided-section>
</template>

<script>
import DividedSection from "@/components/structure/DividedSection"
import ContainerTitle from "@/components/utils/ContainerTitle"
import CircularButton from "@/components/utils/CircularButton"

export default {
    components: {
        "divided-section": DividedSection,
        "container-title": ContainerTitle,
        "circular-button": CircularButton,
    },
    data() {
        return {
            imgSrc: require("@/assets/images/somos.png")
        }
    },
    mounted() {
        document
            .querySelector("#sek-blog")
            .setAttribute("style", `height: ${document.querySelector("#sek-blog .left-section").offsetHeight}px;`)
    }
}
</script>

<style lang="scss">
#sek-blog {
    .left-section, .right-section {
        background: #007ac0;
        min-height: 430px;
    }

    .left-section {
        position: relative;

        .container-title {
            margin-top: 40px;
            margin-bottom: 60px;
        }

        .sek-blog-description {
            font-size: 28px;
            font-weight: bold;
            margin-bottom: 0px;
            line-height: 32px;
            white-space: pre-line;
            position: relative;
            text-indent: 25px;
            text-align: justify;

            h5 {
                font-size: 16px;
                position: absolute;
                right: 168px;
                bottom: -28px;
            }
        }

        .sek-blog-section-left-btn {
            border-width: 2px;
        }

        .btns {
            button {
                background: rgba(0,0,0,0.3) !important;
            }
        }
    }

    .right-section {
        box-shadow:  none !important;
        display: flex;
        align-items: center;

        img {
            width: 375px;
            height: 375px;
            filter: drop-shadow(0px 0px 3px rgba(0,0,0,0.5));
        }
    }
}
@media screen and (max-width: 480px) {
    #sek-blog {
        height: unset !important;
    }
}
</style>